export const placementTypes = Object.freeze({
  sideMenuPage: 'side-menu-page',
  componentTab: 'component-tab',
})

const buildPlacementType = ({ placementType }) => {
  if (placementType === 'component') return placementTypes.componentTab
  return placementTypes.sideMenuPage
}

export const adaptPluginWidgetToPlacement = ({
  widget,
  scope,
  context,
  queryData = null,
}) => {
  if (!_.isPlainObject(widget)) return null

  const rawWidgetId = _.get(widget, 'id')
  if (_.isNil(rawWidgetId)) return null
  // URL params are strings; coerce once at the registry boundary so consumers
  // (route lookup, placement id, iframe context) all compare apples to apples.
  const widgetId = String(rawWidgetId)
  const widgetSlug = _.get(widget, 'url_slug') || widgetId

  const placementType = _.get(widget, 'placement.type')
  const type = buildPlacementType({ placementType })
  const widgetType = _.get(widget, 'type')
  const rawWidgetConfig = _.isPlainObject(_.get(widget, 'widget')) ? _.cloneDeep(widget.widget) : {}
  const placementConfig = _.isPlainObject(_.get(widget, 'placement.config')) ? widget.placement.config : {}

  const iframeContext = (widgetType === 'iframe')
    ? {
        scope,
        orgCanonical: context.orgCanonical,
        projectCanonical: context.projectCanonical,
        envCanonical: context.envCanonical,
        componentCanonical: context.componentCanonical,
        widgetId,
        path: rawWidgetConfig.path,
      }
    : null

  const title = type === placementTypes.componentTab
    ? (placementConfig.tab_name || `Widget ${widgetId}`)
    : (rawWidgetConfig.title || placementConfig.title || `Widget ${widgetId}`)

  const icon = rawWidgetConfig.icon || placementConfig.icon

  return {
    id: `plugin-widget-${scope}-${widgetSlug}`,
    type,
    order: _.get(rawWidgetConfig, 'order', 0),
    labels: { en: title },
    widget: {
      type: widgetType,
      config: {
        ...rawWidgetConfig,
        ...(iframeContext ? { iframeContext } : {}),
        ...(queryData ? { queryData } : {}),
        ...(icon ? { icon } : {}),
        title,
      },
    },
    meta: {
      source: 'plugin-widget-api',
      scope,
      raw: widget,
    },
    widgetSlug,
    requiredActions: ['GetPluginWidgetData'],
  }
}
